var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 596.48 457.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maskPath",
    d: "M3345.024,8588.767s-31.287-50.868-136.842-74.786-236.6-13.475-272.533-8.983-169.9,36.719-181.127-80.064,207.4-141.6,207.4-141.6,130.933-25.379,200.554-148.9",
    transform: "translate(-2751.099 -8132.96)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maskReveal",
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M3345.024,8588.767s-31.287-50.868-136.842-74.786-236.6-13.475-272.533-8.983-169.9,36.719-181.127-80.064,207.4-141.6,207.4-141.6,130.933-25.379,200.554-148.9",
    transform: "translate(-2751.099 -8132.96)",
    fill: "none",
    stroke: "#ff4b4b",
    strokeWidth: 6,
    strokeDasharray: "8 5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath5);
export default __webpack_public_path__ + "static/media/path-5.5f5c596a.svg";
export { ForwardRef as ReactComponent };